// extracted by mini-css-extract-plugin
export default {"form":"form--VD6h","actions":"actions--6paE","sent":"sent--uhxy"};